import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Logo from "../assets/image/logo.png";
import Icon from "../assets/image/news 1.svg";
import Icon1 from "../assets/image/Layer_1(1).png";
import Fantasy from "../assets/image/Layer_1.svg";
// import comunity from "../assets/image/comunity.svg";
import Icon2 from "../assets/image/menu-icon2.svg";
import Icon3 from "../assets/image/menu-icon3.svg";
import Icon4 from "../assets/image/menu-icon4.svg";
import Icon5 from "../assets/image/Wallet.svg";
import ShopIcon from "../assets/image/shop.svg";
import Icon6 from "../assets/image/menu-icon6.svg";
import Icon7 from "../assets/image/menu-icon7.svg";
import LeftArrow from "../assets/image/left-arrow.png";
import SocialIcon from "../assets/image/social.svg";
import facebook from "../assets/image/facebook.svg";
import instagram from "../assets/image/instagram.svg";
import twitter from "../assets/image/twitter.svg";
import linkedin from "../assets/image/linkedin.svg";
import "../style/component/sidebar.css";
import {
  ProfileImage,
  getUserData,
  UpdatedData,
  gettingDailyReward,
} from "../redux/selectors/selector";
import Tour from "./tour";
import { Get, Postdata } from "../utils/api.services";
import HttpService from "../utils/https.services";
import { toast } from "react-toastify";
import { LockUpgradeModal } from "../utils/modal";
import { EVENTS, trackEvent } from "../component/mixpanel";
import {
  hideProfileSideMenu,
  showProfileSideMenu,
} from "../utils/profileMenuNavigation";
import {
  getProfileFailure,
  getProfileRequest,
  getProfileSuccess,
} from "../redux/actions/profile/profile.action";
import {
  getHasSeenTour,
  setHasSeenTour,
  initTourStateForUser,
  TOUR_COMPLETED_EVENT,
} from "../utils/tourStorage.js";
import { AF_EVENTS, trackAFEvent } from "../component/appsflyer";

const HamburgerMenuIcon = () => (
  <svg
    className="menu-hamburger-icon"
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M4 7H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M4 12H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M4 17H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const Sidebar = ({ openNotificationModal }) => {
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [tourSteps, setTourSteps] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getProfile = useSelector(ProfileImage);
  const [updatedValue, setUpdatedValue] = useState("");
  const [profileData, setProfileData] = useState([]);
  const userId = profileData?._id;
  const tourStatus = userId ? getHasSeenTour(userId) : localStorage.getItem("hasSeenTour");
  const [isModalActive, setModalActive] = useState(false);
  const isDailyRewardGetting = useSelector(gettingDailyReward);
  const [numberOfClicks, setnumberOfClicks] = useState(0);
  const [numberOfLMSClicks, setNumberOfLMSClicks] = useState(0);
  const profileClicks = localStorage.getItem("profileClicks");
  const lmsClicks = localStorage.getItem("lmsClicks");
  const profileChance = localStorage.getItem("giveProfileChance");
  const [isExpanded, setIsExpanded] = useState(false);
  const hasStartedTourRef = useRef(false);
  const socialTriggerRef = useRef(null);
  const socialPanelRef = useRef(null);
  const ignoreOutsideClickRef = useRef(false);
  const [markRead, setMarkRead] = useState(
    localStorage.getItem("markAsRead") === ("true" || true)
  );

  const toggleContainer = () => {
    setIsExpanded((prev) => {
      if (!prev) {
        ignoreOutsideClickRef.current = true;
      }
      return !prev;
    });
  };

  useEffect(() => {
    if (!isExpanded) return;

    const handleClickOutside = (event) => {
      if (ignoreOutsideClickRef.current) {
        ignoreOutsideClickRef.current = false;
        return;
      }

      const clickedInsideTrigger = socialTriggerRef.current?.contains(
        event.target
      );
      const clickedInsidePanel = socialPanelRef.current?.contains(event.target);

      if (!clickedInsideTrigger && !clickedInsidePanel) {
        setIsExpanded(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isExpanded]);

  const openModal = () => {
    setModalActive(true);
  };

  const closeModal = () => {
    setModalActive(false);
  };

  const sidebarSteps = [
    {
      target: ".logo",
      title: "Home Screen",
      content:
        "This is your starting point in Rally Bulls. Use your Home Screen to discover everything from risk-free trading and market research to courses, games, and more.",
      placement: "right",
      disableBeacon: true,
      spotlightPadding: 12,
    },
    {
      target: ".tour-trading",
      title: "Trading",
      content:
        "Practice trading with real-time market data and build your skills risk-free.",
      placement: "right",
      disableBeacon: true,
      spotlightPadding: 12,
    },
    {
      target: ".investment-research-main",
      title: "Investment Research Hub",
      content:
        "Get market insights, research, and analysis to make smarter decisions.",
      placement: "bottom",
      disableBeacon: true,
      spotlightPadding: 10,
    },
    {
      target: ".toro-container-main",
      title: "Toro AI Co-Pilot",
      content:
        "Your AI Co-Pilot — ask questions, explore market ideas and strategies, along with help across Rally Bulls.",
      placement: "bottom",
      disableBeacon: true,
      spotlightPadding: 10,
    },
    {
      target: ".tour-fantasy",
      title: "Fantasy",
      content:
        "Trade just like fantasy sports — build your lineup, compete with others, and play in single-round and multi-round leagues.",
      placement: "right",
      disableBeacon: true,
      spotlightPadding: 12,
    },
    {
      target: ".tour-games",
      title: "Games",
      content:
        "Put your market knowledge to the test with daily market projections and quizzes.",
      placement: "right",
      disableBeacon: true,
      spotlightPadding: 12,
    },
    {
      target: ".tour-courses",
      title: "Courses",
      content:
        "Build your financial knowledge with bite-sized lessons, reinforce it with quizzes, and earn certifications as you progress.",
      placement: "right",
      disableBeacon: true,
      spotlightPadding: 12,
    },
    {
      target: ".tour-account-menu",
      title: "Account Menu",
      content:
        "Upgrade to a Premium subscription, along with managing your profile, settings, and other account features.",
      placement: "right",
      disableBeacon: true,
      spotlightPadding: 12,
    },
    {
      target: ".tour-rally-coins",
      title: "Rally Coins",
      content:
        "Earn Rally Coins through Games, Fantasy, Courses, and Quizzes — spend them in the RB Shop and climb the leaderboard.",
      placement: "right",
      disableBeacon: true,
      spotlightPadding: 12,
    },
    {
      target: ".tour-rb-shop",
      title: "RB Shop",
      content:
        "Turn your Rally Coins into real rewards — like gift cards, coupons, and more in the RB Shop.",
      placement: "bottom",
      disableBeacon: true,
      spotlightPadding: 10,
    },
    {
      target: ".tutorial-video-main",
      title: "Tutorial Videos",
      content:
        "Get started with step-by-step video tutorials that show you how to use Rally Bulls and get the most from every feature.",
      placement: "bottom",
      disableBeacon: true,
      spotlightPadding: 10,
    },
  ];

  // const sidebarSteps = [
  //   {
  //     target: ".empty-step",
  //   },
  //   {
  //     target: ".logo",
  //     content:
  //       "Your Dashboard is your gateway to quick access! Manage your profile, stay informed with the latest news, and connect with the community—all in one place.",
  //   },
  //   {
  //     // target: ".toro-container",
  //     target: ".toro-container-main",
  //     content:
  //       "Meet Toro, your AI-powered trading companion! Toro provides personalized insights, educational resources, and real-time support to help you on your trading journey. Tap the Toro icon at the bottom corner of any screen to get started.",
  //   },
  //   {
  //     // target: ".investment-research-container",
  //     target: ".investment-research-main",
  //     content:
  //       "Use the Investment Research Module to access key metrics, financial data, and proprietary insights—empowering you to make informed decisions.",
  //   },
  //   {
  //     target: ".menu li:nth-child(1)",
  //     content:
  //       "Stay ahead with real-time market updates from top publications. Get the latest news to make informed trading decisions.",
  //   },
  //   {
  //     target: ".menu li:nth-child(2)",
  //     content:
  //       "Connect with the Rally Bulls community! Join forums, chats, and groups to share strategies, ask questions, and grow with fellow traders.",
  //   },
  //   {
  //     target: ".menu li:nth-child(7)",
  //     content:
  //       "Track your virtual funds easily! Check your Rally Wallet balance here and stay on top of your finances.",
  //   },
  //   {
  //     target: ".menu li:nth-child(3)",
  //     content:
  //       " Join or create a fantasy trading league with Rally Bulls! Compete, strategize, and climb the leaderboard in a fun, risk-free way.",
  //   },
  //   {
  //     target: ".menu li:nth-child(4)",
  //     content:
  //       "Join or create Games to compete with the Rally Bulls Community! Hone your strategies, showcase your skills, and win exciting rewards.",
  //   },
  //   {
  //     target: ".menu li:nth-child(5)",
  //     content:
  //       "Start building your portfolio in the Trading module! Practice and refine your strategies using real-time data—all without financial risk. ",
  //   },
  //   {
  //     target: ".menu li:nth-child(6)",
  //     content:
  //       "Discover courses tailored to all skill levels, test your knowledge with quizzes, and earn certificates to showcase your expertise!",
  //   },

  //   // {
  //   //   target: '.menu li:nth-child(8)',
  //   //   content: 'View the global leaderboard.',
  //   // },
  //   {
  //     target: ".menu-profile",
  //     content:
  //       "View your profile for badges, achievements, and settings! Manage your account and customize your experience effortlessly.",
  //   },
  // ];

  // Removed: profileSteps and lmsSteps — onboarding is now a single unified home tour.

  const isActive = (path) => {
    return location.pathname.includes(path);
  };

  const FetchProfileData = () => {
    dispatch(getProfileRequest());
    Get(HttpService()?.getProfile)
      .then((response) => {
        if (response?.status) {
          const profile = response.data[0];
          setUpdatedValue(profile.profile_pic);
          setProfileData(profile);
          initTourStateForUser(profile?._id, {
            isNewSignup: false,
            isHome: profile?.is_home !== false,
          });
          dispatch(getProfileSuccess(profile));
        } else {
          toast.error(response?.message);
          dispatch(getProfileFailure(response?.message));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const openNotification = () => {
    navigate("/home", { state: { showNotification: true } });
  };

  console.log(profileData, "profileData!!!!!!!!!!");

  useEffect(() => {
    FetchProfileData();
    localStorage.setItem("profileClicks", 0);
    localStorage.setItem("lmsClicks", 0);
  }, []);

  // useEffect(() => {
  //   if (
  //     (profileData?.is_home || profileData?.is_sidemenu || profileData?.is_lms) &&
  //     tourStatus === 'false' &&
  //     isSignupRewardGetting
  //   ) {
  //     setIsTourOpen(true);
  //     localStorage.setItem('hasSeenTour', 'true');
  //   }
  // }, [tourStatus, isSignupRewardGetting, profileClicks, lmsClicks]);

  // useEffect(() => {
  //   console.log(92, { isTourOpen });
  // }, [isTourOpen]);

  const startTour = () => {
    setTourSteps(sidebarSteps);
    setIsTourOpen(false);
    requestAnimationFrame(() => {
      setIsTourOpen(true);
    });
  };

  useEffect(() => {
    if (location.pathname !== "/home") {
      return;
    }

    if (tourStatus !== "false") {
      hasStartedTourRef.current = false;
      return;
    }

    if (hasStartedTourRef.current) {
      return;
    }

    hasStartedTourRef.current = true;
    startTour();
  }, [tourStatus, location.pathname, userId]);

  const handleProfileClick = () => {};

  const handleLMSClick = () => {};

  const completeTour = () => {
    setIsTourOpen(false);
    setHasSeenTour(userId, true);
    window.dispatchEvent(new CustomEvent(TOUR_COMPLETED_EVENT));
    if (profileData?.is_home === true) {
      handleAchiveReward();
    }
  };

  const handleAchiveReward = () => {
    const path = location.pathname;
    const type = path.includes("/home/profile")
      ? "is_sidemenu"
      : path.includes("/lms")
        ? "is_lms"
        : "is_home";
    Postdata(HttpService()?.achiveRewards, { type })
      .then((result) => {
        if (result?.status) {
          if (type === "is_home") {
            localStorage.setItem("hasAchievedHomeReward", true);
          } else if (type === "is_sidemenu") {
            localStorage.setItem("hasAchievedSidemenuReward", true);
          } else if (type === "is_lms") {
            localStorage.setItem("hasAchievedLMSReward", true);
          }
          // toast.success(result?.message);
        } else {
          toast.error(result?.message);
        }
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message);
      });
  };

  // const isActive = (path) => {
  //   return location.pathname.includes(path);
  // };

  // const openNotification = () => {
  //   navigate("/home", { state: { showNotification: true } });
  // };

  // useEffect(() => {
  //   FetchProfileData()
  //   localStorage.setItem("profileClicks", 0);
  //   localStorage.setItem("lmsClicks", 0);
  // }, []);

  // const FetchProfileData = () => {
  //   Get(HttpService()?.getProfile)
  //     .then((response) => {
  //       console.log(331, response)
  //       if (response?.status) {
  //         setUpdatedValue(response.data[0].profile_pic)
  //       } else {
  //         // toast.error(response?.message);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  // useEffect(() => {

  //   if (tourStatus === "false" && isSignupRewardGetting) {
  //     console.log(94, "open now");
  //     setIsTourOpen(true);
  //     localStorage.setItem("hasSeenTour", "true");
  //   }
  //   if (
  //     tourStatus === "true" &&
  //     isSignupRewardGetting &&
  //     (profileClicks === "1" || lmsClicks === "1") &&
  //     profileChance === "true"
  //   ) {
  //     console.log(92, "here");
  //     setIsTourOpen(true);
  //     localStorage.setItem("hasSeenTour", "true");
  //   }
  // }, [tourStatus, isSignupRewardGetting, profileClicks, lmsClicks]);

  // useEffect(() => {
  //   console.log(92, { isTourOpen });
  //   handleAchiveReward();
  // }, [isTourOpen]);

  console.log(getProfile, "getProfile", localStorage.getItem("profileClicks"));

  useEffect(() => {
    const handleMarkAsRead = () => {
      if (localStorage.getItem("markAsRead") === "true") {
        FetchProfileData(); // ✅ Fetch profile
        localStorage.removeItem("markAsRead"); // ✅ Clear localStorage
        setMarkRead(false); // ✅ Update state
      }
    };

    window.addEventListener("markAsRead", handleMarkAsRead); // ✅ Listen for custom event

    return () => {
      window.removeEventListener("markAsRead", handleMarkAsRead); // Cleanup
    };
  }, []);

  return (
    <div className="sidemenu">
      <Tour
        steps={tourSteps}
        isOpen={isTourOpen}
        onRequestClose={() => setIsTourOpen(false)}
        onCompleteTour={completeTour}
      />
      {/* {(location.pathname === "/home" ||
        (location.pathname === "/home/profile" && profileChance === "true") ||
        (location.pathname === "/lms" && profileChance === "true")) &&
        isTourOpen && (
          <Tour
            // steps={location.pathname === "/home/profile" && profileChance === "true" ? profileSteps : sidebarSteps}
            steps={
              location.pathname === "/home/profile" && profileChance === "true"
                ? profileSteps
                : location.pathname === "/lms" && profileChance === "true"
                ? lmsSteps
                : sidebarSteps
            }
            isOpen={isTourOpen}
            onRequestClose={() => setIsTourOpen(false)}
          />
        )} */}
      <div className="sidemenu-nav">
        <img src={LeftArrow} alt="leftarrow" />
      </div>
      <div className="sidemenu-wrap d-flex flex-column">
        <ul className="menu d-flex flex-column flex-grow-1">
          <li className="logo">
            <Link
              to="/home"
              onClick={() => {
                trackAFEvent(AF_EVENTS.MP_BOTTOM_HOME, {
                  section: "navigation",
                  action: "click_home",
                });

                trackEvent(EVENTS.MP_BOTTOM_HOME, {
                  section: "navigation",
                  action: "click_home",
                });
              }}
            >
              <img src={Logo} alt="logo" title="Home" />
            </Link>
          </li>
          <li className="tour-trading">
            <NavLink
              to="/paper"
              onClick={() => {
                trackAFEvent(AF_EVENTS.MP_BOTTOM_TRADING, {
                  section: "navigation",
                  action: "click_trading",
                });

                trackEvent(EVENTS.MP_BOTTOM_TRADING, {
                  section: "navigation",
                  action: "click_trading",
                });
              }}
            >
              <img
                src={Icon3}
                alt="Trading"
                className={`paper-trading-icon ${isActive("/paper") ? "active" : ""
                  }`}
              // title="Trading"
              />
            </NavLink>
            <h6 className="">Trading</h6>
          </li>
          <li className="tour-courses">
            <NavLink
              to="/lms"
              onClick={() => {
                // Call trackEvent first
                trackAFEvent(AF_EVENTS.MP_BOTTOM_LMS, {
                  section: "navigation",
                  action: "click_lms",
                });

                trackEvent(EVENTS.MP_BOTTOM_LMS, {
                  section: "navigation",
                  action: "click_lms",
                });

                // Then call the handleLMSClick function
                handleLMSClick();
              }}
            >
              <img
                src={Icon4}
                alt="LMS"
                className={isActive("/lms") ? "active" : ""}
              // title="LMS"
              />
            </NavLink>
            <h6 className="">Courses</h6>
          </li>
          <li className="tour-fantasy">
            <NavLink
              to="/fantasy"
              onClick={() => {
                trackAFEvent(AF_EVENTS.MP_BOTTOM_FANTASY, {
                  section: "navigation",
                  action: "click_fantasy",
                });

                trackEvent(EVENTS.MP_BOTTOM_FANTASY, {
                  section: "navigation",
                  action: "click_fantasy",
                })
              }}
            >
              <img
                src={Fantasy}
                alt="Fantasy"
                className={isActive("/fantasy") ? "active" : ""}
              // title="Fantasy"
              />
            </NavLink>
            <h6 className="">Fantasy</h6>
          </li>
          <li className="tour-games">
            <NavLink
              to="/contest"
              onClick={() => {
                trackAFEvent(AF_EVENTS.MP_BOTTOM_CONTEST, {
                  section: "navigation",
                  action: "click_contest",
                });

                trackEvent(EVENTS.MP_BOTTOM_CONTEST, {
                  section: "navigation",
                  action: "click_contest",
                })
              }}
            >
              <img
                src={Icon2}
                alt="Contest"
                className={isActive("/contest") ? "active" : ""}
              // title="Game"
              />
            </NavLink>
            <h6 className="">Games</h6>
          </li>
          <li>
            <NavLink to="/news">
              <img
                src={Icon}
                alt="News"
                className={isActive("/news") ? "active" : ""}
              // title="News"
              />
            </NavLink>
            <h6 className="">News</h6>
          </li>
          {/* Community menu hidden
          {profileData?.is_community === false ? (
            <li>
              <a onClick={openModal}>
                // https://discord.com/invite/AXyGCwSen9
                <img
                  src={comunity}
                  alt="Community"
                  className={isActive("/community") ? "active" : ""}
                // title="Community"
                />
              </a>
              <h6 className="position-absolute" style={{ left: "14px" }}>
                Community
              </h6>
            </li>
          ) : (
            <li>
              <a
                // href="https://discord.com/login?redirect_to=%2Fchannels%2F1263473150449156177%2F1263473150449156180"
                href="https://discord.com/invite/zAZuB6pnZE"
                target="_blank"
                rel="noopener noreferrer"
              >
                // https://discord.com/invite/AXyGCwSen9
                <img
                  src={comunity}
                  alt="Community"
                  className={
                    isActive("https://discord.com/invite/zAZuB6pnZE")
                      ? "active"
                      : ""
                  }
                // title="Community"
                />
              </a>
              <h6 className="position-absolute" style={{ left: "14px" }}>
                Community
              </h6>
            </li>
          )}
          */}

          <li className="menu-style1 tour-rally-coins">
            <NavLink
              to="/home/profile/wallet"
              onClick={() => hideProfileSideMenu()}
            >
              <img src={Icon5} alt="sidebarIcon5" className="pb-2" />

              <h6 className="">Wallet</h6>
            </NavLink>
          </li>

          <li className="tour-rb-shop">
            <NavLink
              to="/home/profile/shop"
              onClick={() => hideProfileSideMenu()}
            >
              <img src={ShopIcon} alt="Shop" className="pb-2" />
              <h6 className="">Shop</h6>
            </NavLink>
          </li>

          {/* <li>
            <NavLink to="/globalleaderboard/contest">
              <img
                src={Icon6}
                alt="Leaderbard"
                className={`${isActive("/globalleaderboard") ? "active" : ""
                  } mb-2`}
              // title="Leaderboard"
              />
              <h6 className="position-relative" style={{ left: "-14px" }}>
                Leaderboard
              </h6>
            </NavLink>
          </li>
          <li>
            <a href="#" onClick={openNotification} className="mb-2">
              <img src={Icon7} alt="Notification" />
              {profileData?.new_notification === true && (
                <div className="new-notification"> </div>
              )}
            </a>
            <h6 className="position-relative" style={{ left: "-12px" }}>
              Notification
            </h6>
          </li> */}

          <li className="menu-hamburger-item tour-account-menu">
            <Link
              to="/home/profile/plus"
              onClick={() => {
                showProfileSideMenu();
                handleProfileClick();
              }}
            >
              <HamburgerMenuIcon />
              <h6>Menu</h6>
            </Link>
          </li>
        </ul>
        {/* <div className="mt-3 cursor-pointer">
        <img src={SocialIcon} alt="Notification" title="Notification" />
        </div> */}
        <div className="notification-wrapper" ref={socialTriggerRef}>
          <div className=" mt-3 cursor-pointer" onClick={toggleContainer}>
            <img src={SocialIcon} alt="social" title="Social Media" />
          </div>
        </div>
      </div>
      <div
        ref={socialPanelRef}
        className={`text-container ${isExpanded ? "expanded" : ""}`}
      >
        <div className="icon-container">
          <a
            href="https://www.facebook.com/profile.php?id=61564495599218"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={facebook} alt="Facebook" />
          </a>
          <a
            href="https://www.instagram.com/rallybulls/?igsh=ajVpaG55dWs2NGh4"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={instagram} alt="Instagram" />
          </a>
          <a
            href="https://discord.com/login?redirect_to=%2Fchannels%2F1263473150449156177%2F1263473150449156180"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={twitter} alt="Discord" />
          </a>
          <a
            href="https://www.linkedin.com/company/rally-bulls"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={linkedin} alt="LinkedIn" />
          </a>
        </div>
      </div>
      <LockUpgradeModal
        isActive={isModalActive}
        onClose={closeModal}
        title={"Community"}
      />
    </div>
  );
};

export default Sidebar;

//  ----------- Old code -------------------
// useEffect(() => {
//   if (isSignupRewardGetting && profileData?.is_home === true && tourStatus === 'false') {

//     setTourSteps(sidebarSteps);
//     setIsTourOpen(true);

//   }
// }, [isSignupRewardGetting, tourStatus]);

// const handleProfileClick = () => {
//   if (isSignupRewardGetting && profileData?.is_sidemenu === true && tourStatus === 'false') {

//     setTourSteps(profileSteps);
//     setIsTourOpen(true);

//   }
// };

// const handleLMSClick = () => {
//   if (isSignupRewardGetting && profileData?.is_lms === true && tourStatus === 'false') {

//     setTourSteps(lmsSteps);
//     setIsTourOpen(true);

//   }
// };

// const completeTour = () => {
//   setIsTourOpen(false);
//   handleAchiveReward();
// };

// ----------- End-------------------
